import { Clickable } from '@ahmdigital/ui';

type DownloadLinkProps = {
  name: string;
  url: string;
};

const DownloadLink = ({ name, url }: DownloadLinkProps) => (
  <li>
    <Clickable analytics={{ label: name }} icon={{ name: 'document' }} inNewTab to={url}>
      {name}
    </Clickable>
  </li>
);

export default DownloadLink;
